module.exports = __webpack_public_path__ + "static/img/1718086946687.6d10734f.jpg";